module.exports = __webpack_public_path__ + "static/media/dgaclogo_long.cf76298d.png";